import { postRoute } from "../client"
export const roomLeaveRoute = postRoute<{ success: boolean }>("/api/rooms/leave")
